export enum SpecialCombinedTprmFieldTypeName {
    additionalInsuredType = 'additionalInsuredType',
    waiverOfSubrogationCompanyNameType = 'waiverOfSubrogationCompanyNameType',
}
